import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom'
import QueryString from 'query-string';
import { saveSessionEvent } from "../../../session";
import * as Steps from './steps';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import ThankYou from '../Common/ThankYou';
import { getBasicInfo } from '../../../sessionStorage';

export default function Medicare(props) {

  useEffect(() => { saveSessionEvent() }, [props.location])

  const { path } = useParams();

  const SESSION_STORAGE_KEY = 'COVR_MEDICARE';

  const sessionStorageFormState = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY));

  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill')

  const basicInfo  = getBasicInfo();

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 1;
  }

  const newFormState = {
    currentStep: 1,
    steps: {
      basicInfo: Steps.BasicInfo.DefaultFormState(prefill, basicInfo),
    },
  }

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    const nextStep = steps.find(s => s.path === path);

    // prevent submitted app alterations
    if (!sessionStorageFormState && formState.currentStep === (steps.length - 2)) {

      // if they are backing or directly going to another step, send them to product root
      if (formState.currentStep !== nextStep.step) {
        window.location = '/quote/term-health-insurance/medicare'
      }
    }

    if (!nextStep) {
      return;
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path])

  const onNext = () => {
    const nextStep = steps.find(s => s.step === formState.currentStep + 1);

    if (!nextStep) {
      throw new Error("onNext did not find a next step")
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newFormState));

    props.history.push(`/quote/term-health-insurance/medicare/${nextStep.path}`);
    window.scroll(0, 0);
  }

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, steps: { ...formState.steps, [step]: { ...formState.steps[step], [field]: value } } });
  }

  const getHeaderText = () => {
    return "Navigating Medicare";
  }

  const steps = [
    {
      step: 1,
      path: 'basic-info',
      progressTitle: 'Basic Information',
      progressSubtitle: 'Enter your basic information for an estimated cost of insurance.',
      component: (
        <Steps.BasicInfo
          formState={formState.steps.basicInfo}
          onFieldChange={(field, value) => onFieldChange('basicInfo', field, value)}
          onNext={onNext}
          queryString={props.location ? QueryString.parse(props.location.search) : null}
          hideBack={props.landing}
        />
      ),
      hideProgressTracker: true,
    },
    {
      step: 2,
      path: 'thank-you',
      progressTitle: 'ThankYou',
      component: <ThankYou sessionStorageKey={SESSION_STORAGE_KEY} basicInfo={basicInfo} />,
      hideProgressTracker: true,
      hideMainHeader: true
    }
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
  const categories = steps.filter((o) => typeof o.categoryNumber !== 'undefined');
  const totalCategories = Math.max.apply(Math, categories.map(function (o) { return o.categoryNumber; }))

  return (
    <div>
      <Helmet>
        <title>Navigating Medicare - {currentStepObj.progressTitle} </title>
      </Helmet>
      <HeaderStepper title={getHeaderText()} hidden={props.landing || currentStepObj.hideMainHeader} hideProgressTracker={currentStepObj.hideProgressTracker} stepName={currentStepObj.categoryName} step={currentStepObj.categoryNumber} totalSteps={totalCategories}>
        {currentStepObj.component}
      </HeaderStepper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Medicare/Medicare.js